import gql from 'graphql-tag';

export const ACCEPT_RESCHEDULING_OFFER = gql`
  mutation ($localizationOptions: LocalizationOptionsInput, $offerId: String!) {
    acceptReschedulingOffer (localizationOptions: $localizationOptions, offerId: $offerId) {
      message,
      organizationName
    }
  }
`;
